import { BiArrowBack } from "react-icons/bi";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ReportedContent from "./reportedContent";
import ContactUs from "./contactUsQuery";
import classNames from "classnames";
import AuthContext from "context/AuthContext";

const tabBtnClass =
  "inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2";
const tabActiveClass = "border-lime-500 text-lime-500";
const tabBorderNoneClass = "border-transparent";
const TAB_REPORTED_COTENT = "reported_content";
const TAB_CONTACT_US_QUERY = "contact_us_query";

function HelpAndSupport() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
  const { logoutUser, user } = useContext(AuthContext);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [users, setAllUser] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [item, setItem] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [filterData, setFilterData] = useState({
    status: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sort_key: "createdAt",
    sort_type: "desc",
  });
  const manager =
    user?.permission?.find((e) => e.manager === "customers") ?? {};
  const [defaultTab, setDefaultTab] = useState("reported_content");
  const handleTabClick = (action, e) => {
    setDefaultTab(action);
  };

  return (
    <>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <div className="p-10 py-2 pt-4">
              <div className="flex border-b">
                <div className="">
                  <ul className="flex">
                    <li className="mr-0 xl:mr-5">
                      <button
                        onClick={handleTabClick.bind(this, TAB_REPORTED_COTENT)}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_REPORTED_COTENT,
                          [tabBorderNoneClass]:
                            defaultTab !== TAB_REPORTED_COTENT,
                        })}
                      >
                        {t("O_REPORT_CONTENT")}
                      </button>
                    </li>
                    <li className="mx-0 xl:mx-5">
                      <button
                        onClick={handleTabClick.bind(
                          this,
                          TAB_CONTACT_US_QUERY
                        )}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_CONTACT_US_QUERY,
                          [tabBorderNoneClass]:
                            defaultTab !== TAB_CONTACT_US_QUERY,
                        })}
                      >
                        {t("O_CONTACT_US_QUERY")}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              {defaultTab === TAB_REPORTED_COTENT ? (
                <ReportedContent item={item} filterData={filterData} />
              ) : (
                <ContactUs item={item} filterData={filterData} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HelpAndSupport;
